export interface UpdateOrderListSelectionDetailsRequest {
  listId: string
  selectionId: string
  details: {
    orderBranchCode: string
    orderNumber: number | string
    mark: string
    ndc: string
    book: string
    sub: string
    traderCode: string
    donorCode: string
    departmentCode: string
    budgetYear: number | string
    budgetBranchCode: string
    budgetDepartmentCode: string
    budgetExpenseCode: string
    equipType: string
    acceptType: string
    collectionType: string
    appendixCode: string
    shelfType: string
    handlingType: string
  }[]
  revision: number
}

export function UpdateOrderListSelectionDetailsRequestToJSON(
  value: UpdateOrderListSelectionDetailsRequest
): any {
  return {
    list_id: value.listId !== '' ? value.listId : undefined,
    selection_id: value.selectionId !== '' ? value.selectionId : undefined,
    details:
      value.details.length > 0
        ? value.details.map(detail => {
            return {
              order_branch_code:
                detail.orderBranchCode !== ''
                  ? detail.orderBranchCode
                  : undefined,
              order_number:
                detail.orderNumber !== '' ? detail.orderNumber : undefined,
              mark: detail.mark !== '' ? detail.mark : undefined,
              ndc: detail.ndc !== '' ? detail.ndc : undefined,
              book: detail.book !== '' ? detail.book : undefined,
              sub: detail.sub !== '' ? detail.sub : undefined,
              trader_code:
                detail.traderCode !== '' ? detail.traderCode : undefined,
              donor_code:
                detail.donorCode !== '' ? detail.donorCode : undefined,
              department_code:
                detail.departmentCode !== ''
                  ? detail.departmentCode
                  : undefined,
              budget_year:
                detail.budgetYear !== '' ? detail.budgetYear : undefined,
              budget_branch_code:
                detail.budgetBranchCode !== ''
                  ? detail.budgetBranchCode
                  : undefined,
              budget_department_code:
                detail.budgetDepartmentCode !== ''
                  ? detail.budgetDepartmentCode
                  : undefined,
              budget_expense_code:
                detail.budgetExpenseCode !== ''
                  ? detail.budgetExpenseCode
                  : undefined,
              equip_type:
                detail.equipType !== '' ? detail.equipType : undefined,
              accept_type:
                detail.acceptType !== '' ? detail.acceptType : undefined,
              collection_type:
                detail.collectionType !== ''
                  ? detail.collectionType
                  : undefined,
              appendix_code:
                detail.appendixCode !== '' ? detail.appendixCode : undefined,
              shelf_type:
                detail.shelfType !== '' ? detail.shelfType : undefined,
              handling_type:
                detail.handlingType !== '' ? detail.handlingType : undefined
            }
          })
        : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
